export const filterDocumentsBySearchTerm = (
  documents: any[],
  searchTerm: string
): any[] => {
  if (!searchTerm.trim()) {
    return documents;
  }

  const searchLower = searchTerm.toLowerCase();

  return documents.filter((document: any) => {
    // Search in name.
    if (document.name && document.name.toLowerCase().includes(searchLower)) {
      return true;
    }

    // Search in description.
    if (
      document.description &&
      document.description.toLowerCase().includes(searchLower)
    ) {
      return true;
    }

    // Search in type.
    if (document.type && document.type.toLowerCase().includes(searchLower)) {
      return true;
    }

    // Search in documentType.
    if (
      document.documentType &&
      document.documentType.toLowerCase().includes(searchLower)
    ) {
      return true;
    }

    // If document has parsed data, search in that too.
    if (document.data) {
      try {
        const parsedData = JSON.parse(document.data);
        if (
          parsedData.name &&
          parsedData.name.toLowerCase().includes(searchLower)
        ) {
          return true;
        }
        if (
          parsedData.description &&
          parsedData.description.toLowerCase().includes(searchLower)
        ) {
          return true;
        }
        if (
          parsedData.type &&
          parsedData.type.toLowerCase().includes(searchLower)
        ) {
          return true;
        }
      } catch (error) {
        // If JSON parsing fails, continue with other searches
      }
    }

    return false;
  });
};
